$(document).ready(function () {
    $('#btnFilter').click(function(e) {
        $('#filterDesk').addClass('opn-filter');
        $('.ctn-filter-modal').toggleClass('open-sidebox');
        $('.ctn-filter-modal').removeClass('d-none');
        $('.backdrop').toggleClass('open-backdrop');
        e.stopPropagation();
    });
    
    $('#btnCloseFilter').click(function() {
        closeCatFilter();
    });
    $('#btnCloseFilter').click(function() {
        $('#filterDesk').removeClass('opn-filter');
        $('#filterDesk').addClass('d-none');
    });
    $('#btnOpenFilter').click(function() {
        $('#filterDesk').addClass('opn-filter');
        $('.ctn-filter-modal').toggleClass('open-sidebox');
        $('.ctn-filter-modal').removeClass('d-none');
        $('.backdrop').toggleClass('open-backdrop');
    });

    // Mobile e desktop dentro do #filterDesk — click only
    $(document).on('click', '.mdl-selos', function(e) {
        var $parent = $(this).closest('.mdl-selos');
        $('.mdl-selos').not($parent).removeClass('is-open');
        $parent.toggleClass('is-open');
        e.stopPropagation();
    });

    // Fecha a modal de filtros ao clicar no backdrop
    $('.backdrop').click(function() {
        closeCatFilter();
    });

    // Fecha as sanfonas internas ao clicar fora delas (em qualquer outro lugar)
    $(document).on('click', function() {
        $('.mdl-selos').removeClass('is-open');
    });

    // Fix para Totem/Touch (intercepta o toque antes do clique)
    $(document).on('touchstart click', '.btn-close-sidebox, .click-only.filterDesk', function(e) {
        e.preventDefault();
        closeCatFilter();
    });
});

function closeCatFilter() {
    $('#filterDesk').removeClass('opn-filter');
    $('.ctn-filter-modal').removeClass('open-sidebox');
    $('.ctn-filter-modal').addClass('d-none');
    $('.backdrop').removeClass('open-backdrop');
    $('.mdl-selos').removeClass('is-open');
}